<template>
    <trax-ui-card :title="lang.polaris.dashboard.save_and_sign" title-bold="1">

        {{ text }}

        <div class="mt-3">
            <button class="btn btn-round btn-default" @click="save()" v-if="saveButton == true">
                {{ lang.polaris.dashboard.save }}
            </button>    

            <button class="btn btn-round btn-default" data-toggle="modal" :data-target="'#'+id+'-reset'" v-if="saveButton == true">
                {{ lang.polaris.dashboard.reset_sheet }}
            </button>    

            <button class="btn btn-round btn-danger" @click="sign()" v-if="signButton == true">
                {{ lang.polaris.dashboard.save_and_sign }}
            </button> 
        </div>

        <!-- Signature modal -->

        <trax-ui-modal-default :id="id+'-sign'" :bus="bus" :title="lang.polaris.dashboard.signature">
            <enac-atpl-dashboard-item-save-sign-popup :id="id+'-sign'" :bus="bus"></enac-atpl-dashboard-item-save-sign-popup>
        </trax-ui-modal-default>

        <!-- Reset confirm modal -->

        <trax-ui-modal-confirm :id="id+'-reset'" :title="lang.polaris.dashboard.reset_sheet" :bus="bus">
            {{ lang.polaris.dashboard.reset_sheet_confirm }}
        </trax-ui-modal-confirm>

        <!-- Local toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :options="toastrOptions" :labels="toastrLabels" passed-label="1" 
            :bus="bus" v-if="!toastrDisabled">
        </trax-ui-toastr>

    </trax-ui-card>
</template>

<script>
    export default {

        props: {
            text: null,
            id: {default: 'enac-atpl-dashboard-item-save-sign'},
            source: {default: 'final'},
            target: {default: '1'},
            toastrDisabled: null,
            toastrOptions: null,
            toastrLabels: null,
            saveButton: {default: true},
            signButton: {default: true},
            signRedirect: {default: true}
        },

        data: function() {
            return {
                lang: lang,
                registration: data.registration,
                item: data.item,
                learner: data.learner,
                user: user,
                endpointBase: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/learning-units/'+data.item.id+'/learners',
                bus: this.$bus
            }
        },

        computed: {

            endpoint: function() {
                return this.learner ? this.endpointBase+'/'+this.learner.id : this.endpointBase;
            }
        },

        created: function() {
            this.bus.$on(this.id+'-'+this.source+'-states-save', this.postData);
            this.bus.$on(this.id+'-sign-created', this.signed);
            this.bus.$on(this.id+'-reset-confirmed', this.reset);
            this.getData();
        },

        methods:  {

            save: function() {
                this.bus.$emit(this.id+'-'+this.target+'-states-save', {summary: {sign: 'author'}});
            },

            sign: function() {
                this.bus.$emit(this.id+'-'+this.target+'-states-save', {summary: {sign: 'validation'}, preflight: true});
            },

            signnow: function() {
                this.bus.$emit(this.id+'-sign-create');
            },

            signed: function() {
                this.bus.$emit(this.id+'-'+this.target+'-states-save', {summary: {sign: 'validation'}});
            },

            getData() {
                var that = this;
                axios.get(this.endpoint)
                    .then(function (response) {
                        response.data.data.included = response.data.included
                        that.bus.$emit(that.id+'-states-data', response.data.data);
                    })
                    .catch(function (error) {
                    });
            },
            
            postData(data) {
                var that = this;
                axios.post(this.endpoint, data)
                    .then(function (response) {
                        if (response.status == 204) return that.signnow();
                        response.data.data.included = response.data.included
                        that.bus.$emit(that.id+'-states-updated', response.data.data);
                        that.bus.$emit(that.id+'-toastr-success');
                        if (data.summary.sign == 'validation' && that.signRedirect == true) {
                            window.location = '../'+that.learner.id;
                        }
                    })
                    .catch(function (error) {
                        if (error.response.data.errors) {
                            that.processErrors(error.response.data.errors);
                            that.bus.$emit(that.id+'-toastr-error', that.lang.polaris.form.form_error);
                        } else {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data);
                        }
                    });
            },

            processErrors(errors) {
                for (var name in errors) {
                    var error = errors[name];
                    if (error instanceof Array) errors[name] = error[0];
                }
                this.bus.$emit(this.id+'-states-errors', errors);
            },

            reset() {
                var that = this;
                axios.delete(this.endpoint)
                    .then(function (response) {
                        response.data.data.included = response.data.included
                        that.bus.$emit(that.id+'-states-updated', response.data.data);
                        that.bus.$emit(that.id+'-toastr-success');
                    })
            }
        }

    }
</script>
